import React from 'react';
import { motion } from 'framer-motion';
import { FaMobile } from 'react-icons/fa';
import { trackEvent } from '../utils/analytics';

const RecommendBookies = () => {
  return (
    <motion.div
      className="mt-12 mb-12"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      {/* Header */}
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center gap-3">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white text-center">
            <FaMobile className="inline-block mr-2 text-blue-500" /> 
            RECOMMENDED BOOKIES
          </h2>
        </div> 
      </div>

      {/* Bookies */}
      <div className="space-y-6">
        {/* 1xBet */}
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl p-4 md:p-6 shadow-lg border border-gray-200 dark:border-gray-700"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="flex flex-col gap-4">
            {/* Верхний ряд: Лого + Заголовок + Рейтинг */}
            <div className="flex items-start justify-between gap-3">
              {/* Логотип и основная информация */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="flex-shrink-0">
                  <img 
                    src="/logos/1xbet.png" 
                    alt="1xBet" 
                    className="w-12 h-12 md:w-16 md:h-16 rounded-full object-contain bg-white p-2"
                    width="64"
                    height="64"
                  />
                </div>
                
                {/* Заголовок и подзаголовок */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1 leading-tight">
                    150% Deposit Bonus
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-300 leading-tight">
                    *Only for new 1xBet customers
                  </p>
                </div>
              </div>
              
              {/* Рейтинг - справа */}
              <div className="flex-shrink-0 text-center">
                <span className="text-xs text-gray-600 dark:text-gray-300 block mb-1">Rating</span>
                <div className="flex justify-center gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Средний ряд: Промо код */}
            <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3">
              <div className="text-center">
                <span className="text-xs md:text-sm text-gray-600 dark:text-blue-300 block mb-1">PROMO CODE</span>
                <div className="text-xl md:text-2xl font-bold text-blue-600 dark:text-blue-400">
                  [ BONUSMB ]
                </div>
              </div>
            </div>
            
            {/* Нижний ряд: Кнопка + Иконки платформ */}
            <div className="flex flex-col gap-3">
              {/* Кнопка - растягивается на всю ширину */}
              <div className="w-full">
                <a
                  href="/1xbet"
                  target="_blank"
                  rel="nofollow noreferrer"
                  onClick={() => trackEvent('click-1xbet')}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 md:px-6 py-3 rounded-lg font-semibold text-center transition-colors duration-200 flex items-center justify-center gap-2 w-full"
                >
                  Go To 1xBet
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              
              {/* Иконки платформ - по центру */}
              <div className="flex justify-center gap-2">
                <div className="bg-green-700 rounded-lg p-2 flex items-center justify-center">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zM20.5 8c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM15.53 2.16l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zM15 5h-1V4h1v1z"/>
                  </svg>
                </div>
                <div className="bg-gray-900 rounded-lg p-2 flex items-center justify-center">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* MelBet */}
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl p-4 md:p-6 shadow-lg border border-gray-200 dark:border-gray-700"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="flex flex-col gap-4">
            {/* Верхний ряд: Лого + Заголовок + Рейтинг */}
            <div className="flex items-start justify-between gap-3">
              {/* Логотип и основная информация */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="flex-shrink-0">
                  <img 
                    src="/logos/melbet.png" 
                    alt="MelBet" 
                    className="w-12 h-12 md:w-16 md:h-16 rounded-full object-contain bg-white p-2"
                    width="64"
                    height="64"
                  />
                </div>
                
                {/* Заголовок и подзаголовок */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1 leading-tight">
                    Free Bet + €100
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-300 leading-tight">
                    *Only for new MelBet customers
                  </p>
                </div>
              </div>
              
              {/* Рейтинг - справа */}
              <div className="flex-shrink-0 text-center">
                <span className="text-xs text-gray-600 dark:text-gray-300 block mb-1">Rating</span>
                <div className="flex justify-center gap-0.5">
                  {[...Array(4)].map((_, i) => (
                    <svg key={i} className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Средний ряд: Промо код */}
            <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-3">
              <div className="text-center">
                <span className="text-xs md:text-sm text-gray-600 dark:text-yellow-300 block mb-1">PROMO CODE</span>
                <div className="text-xl md:text-2xl font-bold text-yellow-600 dark:text-yellow-400">
                  [ MAINBONUS ]
                </div>
              </div>
            </div>
            
            {/* Нижний ряд: Кнопка + Иконки платформ */}
            <div className="flex flex-col gap-3">
              {/* Кнопка - растягивается на всю ширину */}
              <div className="w-full">
                <a
                  href="https://main-bet.com/melbet"
                  target="_blank"
                  rel="nofollow noreferrer"
                  onClick={() => trackEvent('click-melbet')}
                  className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 md:px-6 py-3 rounded-lg font-semibold text-center transition-colors duration-200 flex items-center justify-center gap-2 w-full"
                >
                  Go To MelBet
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              
              {/* Иконки платформ - по центру */}
              <div className="flex justify-center gap-2">
                <div className="bg-green-700 rounded-lg p-2 flex items-center justify-center">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zM20.5 8c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM15.53 2.16l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zM15 5h-1V4h1v1z"/>
                  </svg>
                </div>
                <div className="bg-gray-900 rounded-lg p-2 flex items-center justify-center">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* BetWinner */}
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl p-4 md:p-6 shadow-lg border border-gray-200 dark:border-gray-700"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="flex flex-col gap-4">
            {/* Верхний ряд: Лого + Заголовок + Рейтинг */}
            <div className="flex items-start justify-between gap-3">
              {/* Логотип и основная информация */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="flex-shrink-0">
                  <img 
                    src="/logos/betwinner.png" 
                    alt="BetWinner" 
                    className="w-12 h-12 md:w-16 md:h-16 rounded-full object-contain bg-white p-2"
                    width="64"
                    height="64"
                  />
                </div>
                
                {/* Заголовок и подзаголовок */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1 leading-tight">
                    €100 Welcome Bonus
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-300 leading-tight">
                    *Only for new BW customers
                  </p>
                </div>
              </div>
              
              {/* Рейтинг - справа */}
              <div className="flex-shrink-0 text-center">
                <span className="text-xs text-gray-600 dark:text-gray-300 block mb-1">Rating</span>
                <div className="flex justify-center gap-0.5">
                  {[...Array(4)].map((_, i) => (
                    <svg key={i} className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  ))}
                  <svg className="w-3 h-3 md:w-4 md:h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fillOpacity="0.5"/>
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Средний ряд: Промо код */}
            <div className="bg-green-50 dark:bg-green-900/20 rounded-lg p-3">
              <div className="text-center">
                <span className="text-xs md:text-sm text-gray-600 dark:text-green-300 block mb-1">PROMO CODE</span>
                <div className="text-xl md:text-2xl font-bold text-green-600 dark:text-green-400">
                  [ EUR100 ]
                </div>
              </div>
            </div>
            
            {/* Нижний ряд: Кнопка + Иконки платформ */}
            <div className="flex flex-col gap-3">
              {/* Кнопка - растягивается на всю ширину */}
              <div className="w-full">
                <a
                  href="https://main-bet.com/betwinner"
                  target="_blank"
                  rel="nofollow noreferrer"
                  onClick={() => trackEvent('click-betwinner')}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 md:px-6 py-3 rounded-lg font-semibold text-center transition-colors duration-200 flex items-center justify-center gap-2 w-full"
                >
                  Go To BW
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              
              {/* Иконки платформ - по центру */}
              <div className="flex justify-center gap-2">
                <div className="bg-green-700 rounded-lg p-2 flex items-center justify-center">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zM20.5 8c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zM15.53 2.16l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zM15 5h-1V4h1v1z"/>
                  </svg>
                </div>
                <div className="bg-gray-900 rounded-lg p-2 flex items-center justify-center">
                  <svg className="w-5 h-5 md:w-6 md:h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Parimatch */}
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl p-4 md:p-6 shadow-lg border border-gray-200 dark:border-gray-700"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="flex flex-col gap-4">
            {/* Верхний ряд: Лого + Заголовок + Рейтинг */}
            <div className="flex items-start justify-between gap-3">
              {/* Логотип и основная информация */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="flex-shrink-0">
                  <img 
                    src="/logos/parimatch.png" 
                    alt="Parimatch" 
                    className="w-12 h-12 md:w-16 md:h-16 rounded-full object-contain bg-white p-2"
                    width="64"
                    height="64"
                  />
                </div>
                
                {/* Заголовок и подзаголовок */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1 leading-tight">
                    Welcome 25$
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-300 leading-tight">
                    *Only for new PM customers
                  </p>
                </div>
              </div>
              
              {/* Рейтинг - справа */}
              <div className="flex-shrink-0 text-center">
                <span className="text-xs text-gray-600 dark:text-gray-300 block mb-1">Rating</span>
                <div className="flex justify-center gap-0.5">
                  {[...Array(3)].map((_, i) => (
                    <svg key={i} className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  ))}
                  <svg className="w-3 h-3 md:w-4 md:h-4 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fillOpacity="0.5"/>
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Средний ряд: Промо код */}
            <div className="bg-gray-900 dark:bg-gray-700 rounded-lg p-3">
              <div className="text-center">
                <span className="text-xs md:text-sm text-gray-300 dark:text-gray-400 block mb-1">PROMO CODE:</span>
                <div className="text-lg md:text-xl font-bold text-white">
                  -
                </div>
              </div>
            </div>
            
            {/* Нижний ряд: Кнопка + Рейтинг */}
            <div className="flex flex-col gap-3">
              {/* Кнопка - растягивается на всю ширину */}
              <div className="w-full">
                <a
                  href="https://main-bet.com/parimatch"
                  target="_blank"
                  rel="nofollow noreferrer"
                  onClick={() => trackEvent('click-parimatch')}
                  className="bg-gray-900 hover:bg-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 text-white px-4 md:px-6 py-3 rounded-lg font-semibold text-center transition-colors duration-200 flex items-center justify-center gap-2 w-full"
                >
                  Go to Parimatch
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </motion.div>

        {/* DoubleBet */}
        <motion.div
          className="bg-white dark:bg-gray-800 rounded-xl p-4 md:p-6 shadow-lg border border-gray-200 dark:border-gray-700"
          whileHover={{ scale: 1.02 }}
          transition={{ duration: 0.2 }}
        >
          <div className="flex flex-col gap-4">
            {/* Верхний ряд: Лого + Заголовок + Рейтинг */}
            <div className="flex items-start justify-between gap-3">
              {/* Логотип и основная информация */}
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="flex-shrink-0">
                  <img 
                    src="/logos/db-bet.png" 
                    alt="DoubleBet" 
                    className="w-12 h-12 md:w-16 md:h-16 rounded-full object-contain bg-white p-2"
                    width="64"
                    height="64"
                  />
                </div>
                
                {/* Заголовок и подзаголовок */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1 leading-tight">
                    €130 Welcome Bonus
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600 dark:text-gray-300 leading-tight">
                    *Only for new DB customers
                  </p>
                </div>
              </div>
              
              {/* Рейтинг - справа */}
              <div className="flex-shrink-0 text-center">
                <span className="text-xs text-gray-600 dark:text-gray-300 block mb-1">Rating</span>
                <div className="flex justify-center gap-0.5">
                  {[...Array(3)].map((_, i) => (
                    <svg key={i} className="w-3 h-3 md:w-4 md:h-4 text-yellow-400 fill-current" viewBox="0 0 24 24">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Средний ряд: Промо код */}
            <div className="bg-yellow-50 dark:bg-yellow-900/20 rounded-lg p-3">
              <div className="text-center">
                <span className="text-xs md:text-sm text-gray-600 dark:text-yellow-300 block mb-1">PROMO CODE</span>
                <div className="text-xl md:text-2xl font-bold text-yellow-600 dark:text-yellow-400">
                  [ EUR130 ]
                </div>
              </div>
            </div>
            
            {/* Нижний ряд: Кнопка + Рейтинг */}
            <div className="flex flex-col gap-3">
              {/* Кнопка - растягивается на всю ширину */}
              <div className="w-full">
                <a
                  href="https://main-bet.com/db-bet"
                  target="_blank"
                  rel="nofollow noreferrer"
                  onClick={() => trackEvent('click-doublebet')}
                  className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 md:px-6 py-3 rounded-lg font-semibold text-center transition-colors duration-200 flex items-center justify-center gap-2 w-full"
                >
                  Go to DoubleBet
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default RecommendBookies; 